import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import GmapImg from "../../../assets/user/images/Google_Maps_icon.svg";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import toast from "react-hot-toast";
import { routes } from "../../../utlis/admin/routes.utlis";
import { Formik, Field, Form } from "formik";
import { milesOptions, providerLIMIT } from "../../../utlis/common.utlis";
import LocImg from "../../../assets/user/images/location.svg";
import StarImg1 from "../../../assets/provider/images/starwh.svg";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import NoData from "../../../assets/admin/images/no-data-found.svg";
import BriefcaseImg from "../../../assets/user/images/briefcase.svg";
import HandshakeImg from "../../../assets/user/images/Handshake.svg";
import HouseImg from "../../../assets/user/images/house1.svg";
import StarImg from "../../../assets/user/images/star.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import Loader from "../../../layouts/loader/Loader";
import { decode, encode } from "base-64";
import moment from "moment";

const MoreProvider = () => {
  const navigate = useNavigate();
  const [detailModal, setDetailModal] = useState({ status: false, data: null });
  const [providers, setProvider] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [radius, setRadius] = useState("500");
  const localData = useLocation();
  const id = localData.state?.id ?? null;
  const cateId = localData.state?.cateId ?? null;
  const lat = localData.state?.lat ?? null;
  const lng = localData.state?.lng ?? null;

  const getProviders = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log("all providers list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      const providerData = [];
      for (const key in response.data.data.providers) {
        response.data.data.providers[key].checked = false;
        const itemData = response.data.data.providers[key];
        providerData.push(itemData);
      }
      setProvider((prevData) => [...prevData, ...providerData]);
      if (pageNum == response.data.data.lastPage) {
        setHasMore(false);
      }
      setTotal(response.data.data.total);
    } else {
      setTotal(response.data.data.total);
      setProvider([]);
    }
    setLoading(false);
  };

  const getDetails = async (id) => {
    const response = await ApiService.getAPIWithAccessToken(
      api.providerDetail + id
    );
    if (response.data.status && response.data.statusCode === 200) {
      setDetailModal({ status: true, data: response.data.data });
    } else setDetailModal({ status: false, data: null });
  };

  const addProvider = async (formValue) => {
    setLoading(true);
    const user_id = [];
    providers.forEach((ele) => {
      if (ele.checked) {
        user_id.push(ele.userid);
      }
    });
    if (user_id.length == 0) {
      toast.error("Please select any provider");
      setLoading(false);
      return;
    }
    const form = JSON.stringify({
      request_id: [parseInt(decode(id))],
      user_id: user_id,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.sendRequestProvider,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      navigate(-1);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const handleCheck = (id) => {
    let length = providers.filter((user) => user.checked).length;
    if (
      length >= 3 &&
      !providers.some((user) => user.userid == id && user.checked)
    ) {
      toast.error("You can select up to three care provider & staff only.");
    } else {
      const updatedItems = providers.map((item) =>
        item.userid === id ? { ...item, checked: !item.checked } : item
      );
      setProvider(updatedItems);
    }
  };

  const handleUncheck = () => {
    const updatedItems = providers.map((item) => ({
      ...item,
      checked: false,
    }));
    setProvider(updatedItems);
  };

  const handleLoadMore = () => {
    if (hasMore) {
      setPageNum((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    getProviders(
      api.moreProvider +
        `?request_id=${decode(
          id
        )}&latitude=${lat}&longitude=${lng}&radious=${radius}&categoryid=${cateId}&free_in_home_assessment=${1}&page=${pageNum}&limit=${providerLIMIT}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum, radius]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="carenetwork-section">
          <div className="care-title-header">
            <h2 className="heading-title my-3">Add Providers</h2>
            <div className="search-filter">
              <div className="row g-2">
                <div className="col-md-12">
                  <div className="form-group">
                    <Link
                      className="btn-bl wd100"
                      to=""
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="findcare-content">
            <div className="step-content tab-content">
              <div className="findcare-form">
                <div className="d-flex justify-content-between mb-3">
                  <h2>
                    Choose from {providers.length}/{total ?? 0} Care Provider &
                    Staff
                  </h2>
                </div>
                <div className="col-md-12">
                  <div className="form-group mb-4">
                    <h4>Search By Miles</h4>
                    <div class="findcare-form">
                      <div className="choosemiles-list">
                        <ul>
                          {milesOptions.map((ele, indx) => {
                            return (
                              <li key={indx}>
                                <div className="ceradio1">
                                  <input
                                    type="radio"
                                    name="radius"
                                    id={`${ele.value}miles`}
                                    value={ele.value}
                                    onClick={() => {
                                      setRadius(ele.value);
                                      setPageNum(1);
                                      setHasMore(true);
                                      setProvider([]);
                                      setTotal(0);
                                    }}
                                    defaultChecked={
                                      ele.value == 500 ? true : false
                                    }
                                  />
                                  <label for={`${ele.value}miles`}>
                                    <span className="checkbox-text">
                                      <img src={LocImg} /> {ele.label}{" "}
                                    </span>
                                  </label>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="findcare-card">
                  <Formik
                    initialValues={{}}
                    enableReinitialize
                    onSubmit={addProvider}
                  >
                    <Form>
                      <div className="row">
                        {providers.length !== 0 ? (
                          providers.map((ele, indx) => {
                            return (
                              <div key={indx} className="col-md-4">
                                <div className="findcarecheckbox position-relative">
                                  <input
                                    type="checkbox"
                                    name="user_id"
                                    checked={ele.checked}
                                    onChange={() => handleCheck(ele.userid)}
                                    id={`${ele.userid}proImg`}
                                    value={ele.userid}
                                  />
                                  <label htmlFor={`${ele.userid}proImg`}>
                                    <span className="checkbox-circle-mark"></span>
                                    <div className="findcare-card">
                                      <div className="findcare-card-head">
                                        <div className="findcare-user-info">
                                          <div className="findcare-user-image">
                                            {ele.logo !== null &&
                                            ele.logo !== "" &&
                                            ele.logo !== undefined ? (
                                              <img
                                                src={ele.logo}
                                                alt=""
                                                className="me-3"
                                              />
                                            ) : ele.profile_image === null ||
                                              ele.profile_image === "" ||
                                              ele.profile_image ===
                                                undefined ? (
                                              <img
                                                src={NoImage}
                                                alt=""
                                                className="me-3"
                                              />
                                            ) : (
                                              <img
                                                src={ele.profile_image}
                                                alt=""
                                                className="me-3"
                                              />
                                            )}
                                          </div>
                                          <div className="findcare-user-text">
                                            <div className="findcare-user-name">
                                              {ele?.business_name
                                                ? ele?.business_name
                                                : ele?.fullname}
                                            </div>
                                            <div className="d-flex">
                                              <div className="findcare-user-rating">
                                                <i className="fa fa-star"></i>{" "}
                                                {ele.average_rating ?? "0.0"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="findcare-card-body">
                                        <div className="findcare-pricetag-content">
                                          <div className="strip-text">
                                            {ele.user_type == 2
                                              ? "Provider"
                                              : "Staff"}
                                          </div>
                                        </div>
                                        <div className="d-flex flex-column align-items-start">
                                          <div className="care-price-text">
                                            <div className="exp-text mb-1">
                                              {ele.experience ?? 0} Years
                                              Experience
                                            </div>
                                          </div>
                                          <div>
                                            <div className="tags-item">
                                              {ele.category ?? "NA"}
                                            </div>
                                            <div className="tags-item-sub">
                                              {ele.subcategory ?? "NA"}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="findcare-location-box mt-2">
                                          <div className="care-point-icon">
                                            <img src={GmapImg} />
                                          </div>
                                          <div className="care-point-text mb-5">
                                            <h4>Location</h4>
                                            <p>
                                              {ele.business_address ?? "NA"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </label>
                                  <div
                                    className="text-center mt-2 w-100 provider-list-detail-btn"
                                    style={{
                                      position: "absolute",
                                      top: "74%",
                                    }}
                                  >
                                    <Link
                                      className="viewmorebtn mx-1"
                                      to=""
                                      onClick={(e) => {
                                        e.preventDefault();
                                        getDetails(ele.id);
                                      }}
                                    >
                                      <i className="fa fa-eye"></i> View Profile
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "5% 0",
                            }}
                          >
                            <img width={300} src={NoData} alt="" />
                          </div>
                        )}

                        {providers.length !== 0 && hasMore ? (
                          <div className="form-group w-100 text-center">
                            <button
                              className="btn-bl"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLoadMore();
                              }}
                            >
                              Show More
                            </button>
                          </div>
                        ) : null}

                        {providers.length !== 0 ? (
                          <div className="col-md-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn-bl mx-2"
                                onClick={() => handleUncheck()}
                              >
                                Clear All
                              </button>
                              <button className="btn-gr" type="submit">
                                Submit Service Request
                              </button>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={detailModal.status}
        onHide={() => {
          setDetailModal({ status: false, data: null });
        }}
        className="modal-lg"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Provider Details</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="row">
                <div className="col-md-12">
                  <div className="providerProfile-section">
                    <div className="user-table-item">
                      <div className="row g-1 align-items-center">
                        <div className="col-md-7">
                          <div className="user-profile-item">
                            <div className="user-profile-media">
                              {detailModal?.data?.logo !== null &&
                              detailModal?.data?.logo !== "" &&
                              detailModal?.data?.logo !== undefined ? (
                                <img
                                  src={detailModal?.data?.logo}
                                  alt=""
                                  className="me-3"
                                />
                              ) : detailModal?.data?.profile_image === null ||
                                detailModal?.data?.profile_image === "" ||
                                detailModal?.data?.profile_image ===
                                  undefined ? (
                                <img src={NoImage} alt="" className="me-3" />
                              ) : (
                                <img
                                  src={detailModal?.data?.profile_image}
                                  alt=""
                                  className="me-3"
                                />
                              )}
                            </div>
                            <div className="user-profile-text">
                              <h2>
                                {detailModal?.data?.business_name
                                  ? detailModal?.data?.business_name
                                  : detailModal?.data?.fullname}
                              </h2>
                              <div className="location-text">
                                {detailModal?.data?.business_address ?? "NA"}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="row g-1 align-items-center">
                            <div className="col-md-6">
                              <div className="user-contact-info">
                                <div className="user-contact-info-icon">
                                  <img src={StarImg} />
                                </div>
                                <div className="user-contact-info-content">
                                  <h2>Rating</h2>
                                  <p>
                                    {detailModal?.data?.avarageRating
                                      ?.average_rating ?? "0.0"}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="user-contact-info">
                                <div className="user-contact-info-icon">
                                  <img src={BriefcaseImg} />
                                </div>
                                <div className="user-contact-info-content">
                                  <h2>Experience</h2>
                                  <p>
                                    {detailModal?.data?.experience ?? 0} Years
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="providerProfile-point">
                        <div className="providerprofile-point-item">
                          <img src={HouseImg} /> Cared{" "}
                          {detailModal?.data?.caredFamilys ?? 0} Families
                        </div>
                        <div className="providerprofile-point-item">
                          <img src={HandshakeImg} /> Hired By{" "}
                          {detailModal?.data?.caredFamilyNearBy ?? 0} Families
                          In Your Neighbourhood
                        </div>
                      </div>
                    </div>

                    <div className="providerprofile-overview">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="overview-card">
                            <div className="overview-content">
                              <h2>Repeat Clients</h2>
                              <h4>{detailModal?.data?.repeatClient ?? 0}</h4>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="overview-card">
                            <div className="overview-content">
                              <h2>Response Rate</h2>
                              <h4>{detailModal?.data?.responseRate ?? "0%"}</h4>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="overview-card">
                            <div className="overview-content">
                              <h2>Response Time</h2>
                              <h4>{detailModal?.data?.responseTime ?? "NA"}</h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="providerprofile-about">
                      <h2>About</h2>
                      <p>{detailModal?.data?.description ?? "NA"}</p>
                    </div>

                    <div className="providerprofile-about">
                      <h2>Offering Services</h2>
                      <div>
                        <div className="tags-item">
                          {detailModal?.data?.category ?? "NA"}
                        </div>
                        <div className="tags-item-sub">
                          {detailModal?.data?.subcategory ?? "NA"}
                        </div>
                      </div>
                    </div>

                    <div class="review-card mt-3">
                      <div class="review-card-content">
                        <div class="review-card-icon">
                          <img src={StarImg1} />
                        </div>
                        <div class="review-card-text">
                          <h3>Rating & Review</h3>
                          <p>
                            {detailModal?.data?.avarageRating?.average_rating ?? 0}(
                            {detailModal?.data?.avarageRating?.total_reviews ?? 0})
                          </p>
                        </div>
                      </div>
                      {/* <div class="review-card-action">
                    <link to="">Write your Review</link>
                  </div> */}
                    </div>
                    <div class="care-comment-list">
                      {detailModal?.data?.reviewsList.length !== 0
                        ? detailModal?.data?.reviewsList.map((ele, indx) => {
                            return (
                              <div key={indx} class="care-comment-item">
                                <div class="care-comment-profile">
                                  {ele?.image !== null &&
                                  ele?.image !== "" &&
                                  ele?.image !== undefined ? (
                                    <img src={ele?.image} alt="" />
                                  ) : (
                                    <img src={NoImage} alt="" />
                                  )}
                                </div>
                                <div class="care-comment-content">
                                  <div class="care-comment-head">
                                    <div class="">
                                      <h2>{ele?.fullname ?? "NA"}</h2>
                                      <div class="care-comment-rating">
                                        <i class="fa fa-star"></i>{" "}
                                        {ele?.rating ?? 0}
                                      </div>
                                    </div>
                                    <div class="care-date">
                                      <i class="fa fa-calendar"></i>{" "}
                                      {moment(ele?.modified_date).format(
                                        "MM-DD-yyyy hh:mm A"
                                      )}
                                    </div>
                                  </div>
                                  <div class="care-comment-descr">
                                    {ele?.review ?? "NA"}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group text-end mt-3">
                <button
                  type="button"
                  onClick={() => {
                    setDetailModal({ status: false, data: null });
                  }}
                  className="btn btn-re me-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default MoreProvider;
